import router from "./index";
import cookie from "js-cookie";
import store from "../store";
import { hasRoutePermission, isAdmin } from "@/utils/routerPermission";

function canAccessRoute(to, userRouters, userInfo) {
  if (to.meta && to.meta.adminOnly && !isAdmin(userInfo)) return false;
  if (to.name === "stack") return true;
  return hasRoutePermission(to.meta.key, userRouters, userInfo);
}

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.requireAuth) {
    if (cookie.get("token")) {
      if (store.getters.routers.length === 0) {
        let user = await store.dispatch("getUserInfo");
        store.dispatch("getRouter", user.role_id).then(() => {
          if (store.getters.userRouters.length === 0) {
            next({ name: "errorPage", replace: true });
          } else {
            if (
              canAccessRoute(
                to,
                store.getters.userRouters,
                store.getters.userInfo
              )
            ) {
              next();
            } else {
              next({ name: "errorPage", replace: true });
            }
          }
        });
      } else {
        const { userRouters, userInfo } = store.getters;
        if (to.meta && to.meta.requireAuth && !canAccessRoute(to, userRouters, userInfo)) {
          next({ name: "errorPage", replace: true });
          return;
        }
        next();
      }
    } else {
      store.commit("CLEAR_ROUTER");
      next({ name: "login", query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});
